/**
 * API base URL configuration.
 * On custom domains (production), uses window.location.origin for same-origin requests.
 * On Emergent preview/host domains or localhost, uses the REACT_APP_BACKEND_URL env var.
 */
const envUrl = process.env.REACT_APP_BACKEND_URL || '';

function getBackendUrl() {
  if (typeof window === 'undefined') return envUrl;

  const hostname = window.location.hostname;

  // Local development — use env URL
  if (hostname === 'localhost' || hostname === '127.0.0.1') return envUrl;

  // Any Emergent platform domain — use env URL
  if (hostname.includes('emergentagent.com') || hostname.includes('emergent.host')) return envUrl;

  // Custom domain (e.g. myconciergeportal.com) — same-origin to avoid CORS
  return window.location.origin;
}

export const BACKEND_URL = getBackendUrl();
export const API = `${BACKEND_URL}/api`;
